import { RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";

export type B100120CreateRequest = {
  shohinbunruiKbn: string;
  shodaibun: string;
} & Partial<{
  shochubun: string;
  shoshobun: string;
  shohinbunruiNm: string;
}>;

export const B100120Create = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100120CreateRequest = {
    shohinbunruiKbn: fields.shohinbunruiKbn.value,
    shodaibun: fields.shodaibun,
    shochubun: fields.shochubun,
    shoshobun: fields.shoshobun,
    shohinbunruiNm: fields.shohinbunruiNm,
  };

  return RestClient.post("b100120/create", data);
};

export type B100120UpdateRequest = {
  shohinbunruiKbn: string;
  shodaibun: string;
  version: number;
} & Partial<{
  shochubun: string;
  shoshobun: string;
  shohinbunruiNm: string;
}>;

export const B100120Update = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  let paramVersion;

  if (fields.shohinbunruiKbn.value === "0") {
    paramVersion = fields.daiVersion;
  } else if (fields.shohinbunruiKbn.value === "1") {
    paramVersion = fields.chuVersion;
  } else if (fields.shohinbunruiKbn.value === "2") {
    paramVersion = fields.shoVersion;
  }

  const data: B100120UpdateRequest = {
    shohinbunruiKbn: fields.shohinbunruiKbn.value,
    shodaibun: fields.shodaibun,
    shochubun: fields.shochubun,
    shoshobun: fields.shoshobun,
    shohinbunruiNm: fields.shohinbunruiNm,
    version: paramVersion,
  };

  return RestClient.put("b100120/update", data);
};

export type B100120DeleteRequest = {
  shohinbunruiKbn: string;
  shodaibun: string;
} & Partial<{
  shochubun: string;
  shoshobun: string;
}>;

export const B100120Delete = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100120DeleteRequest = {
    shohinbunruiKbn: fields.shohinbunruiKbn.value,
    shodaibun: fields.shodaibun,
    shochubun: fields.shochubun,
    shoshobun: fields.shoshobun,
  };

  return RestClient.delete("b100120/delete", { data: data });
};
